export default __webpack_public_path__ + "static/media/mirum.7bec7001.svg";